import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const tokens = {
  get access() {
    return localStorage.getItem("vx_access");
  },
  get refresh() {
    return localStorage.getItem("vx_refresh");
  },
  set({ access_token, refresh_token }) {
    if (access_token) localStorage.setItem("vx_access", access_token);
    if (refresh_token) localStorage.setItem("vx_refresh", refresh_token);
  },
  clear() {
    localStorage.removeItem("vx_access");
    localStorage.removeItem("vx_refresh");
  },
};

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = tokens.access;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    if (status === 401 && !original._retry && tokens.refresh) {
      original._retry = true;
      try {
        refreshing =
          refreshing ||
          axios.post(`${API}/auth/refresh`, { refresh_token: tokens.refresh }, { withCredentials: true });
        const { data } = await refreshing;
        refreshing = null;
        tokens.set(data);
        original.headers = { ...original.headers, Authorization: `Bearer ${data.access_token}` };
        return api(original);
      } catch (e) {
        refreshing = null;
        tokens.clear();
        if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(error, fallback = "Something went wrong. Please try again.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (typeof d?.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.reason === "string") return detail.reason;
  return error?.message || fallback;
}

export const get = (url, params) => api.get(url, { params }).then((r) => r.data);